// Trasforma il menu nell'ordinazione da passare al server
/*
{
  products: [{id, quantity}, ...]
  combos: [{id, quantity}, ...]
}
*/
const minimize = (_menu) => {
  const products = _menu.products
    .filter((item) => item.quantity > 0)
    .map((item) => {
      return { id: item.id, quantity: item.quantity };
    });

  const combos = _menu.combos
    .filter((item) => item.quantity > 0)
    .map((item) => {
      return { id: item.id, quantity: item.quantity };
    });
  return { products, combos };
};
export default minimize